// DS: MO 4.1.6
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import ShopLogo from '@wix/da-ds/pkg/ShopLogo';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DeviationPromo from '../DeviationPromo';
import { useSellAction } from '../exclusives/hooks';
const ShopPromo = ({ deviation })=>{
    const { t } = useTranslation();
    // We don't use the hook's biData, we have our own
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [sellAction, _] = useSellAction(deviation);
    return /*#__PURE__*/ React.createElement(DeviationPromo, {
        deviation: deviation,
        onClick: sellAction,
        biData: BiData({
            evid: 353,
            deviationid: deviation.deviationId,
            sectionname: BiContextProvidedValue
        }),
        heading: t('sidebar.shopPromo.heading'),
        subheading: t('sidebar.shopPromo.description'),
        attributionSlot: deviation && t('sidebar.shopPromo.attribution'),
        logoSlot: /*#__PURE__*/ React.createElement(ShopLogo, null),
        ctaSlot: /*#__PURE__*/ React.createElement(BuyButton, {
            rounded: true,
            size: "medium",
            variant: "solid"
        }, t('sidebar.shopPromo.sellCta'))
    });
};
ShopPromo.displayName = 'ShopPromo';
export default ShopPromo;
